import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FsFormatDatePipe } from '@lib/common/pipes';

import { NOTIFICATION_MESSAGES } from '../../constants/notification-messages.constants';
import { IDeviceMarker } from '../../interfaces';
import { AxonNotificationIconService } from '../../services/axon-notification-icon.service';

@Component({
  selector: 'fs-axon-notification-dialog',
  templateUrl: './axon-notification-dialog.component.html',
  styleUrls: ['./axon-notification-dialog.component.scss'],
})
export class AxonNotificationDialogComponent {
  public historicalData: any[] = [];
  public messages = NOTIFICATION_MESSAGES;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly historical: IDeviceMarker,
    private readonly _dialogRef: MatDialogRef<AxonNotificationDialogComponent>,
    private readonly _axonNotificationIconService: AxonNotificationIconService,
  ) {
    this._removeDuplicateHistoricalEntries();
  }

  public formatDate(date: number): string {
    return new FsFormatDatePipe().transform(date, 'medium');
  }

  public generateDeviceName(device: IDeviceMarker): string {
    return device.device.deviceName;
  }

  public close(): void {
    this._dialogRef.close();
  }

  private _removeDuplicateHistoricalEntries(): void {
    if (this.historical?.deviceHistory) {
      const uniqueEntries = this.historical.deviceHistory.reduce((acc, entry) => {
        // Use timestamp and category for uniqueness, ignore the potentially undefined type field
        const uniqueKey = `${entry.attributes.timestamp}-${entry.attributes.category}-${entry.attributes.device.deviceId}`;
        acc.set(uniqueKey, entry);
        return acc;
      }, new Map<string, (typeof this.historical.deviceHistory)[0]>());

      this.historical.deviceHistory = Array.from(uniqueEntries.values());
    }
  }
}
